<template>
  <div class="content">
    <BlockUI v-if="this.blockScreen" :url="blockScreenData.url" :message="blockScreenData.msg"></BlockUI>
    <modalPadrao
        :showModal="modalDialog"
        :ifTitle="true"
        :Title="titleModal"
        :ifTwoBtn="true"
        :TextFirstBtn="'Não'"
        :TextSecondBtn="'Sim'"
        @btnUm="modalDialog = false"
        @btnDois="(action == 'approve') ? approveUser() : deleteUser()"
      ></modalPadrao>
    <v-card>
      <v-card-title>
        Black List
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Procurar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-flex sm6 offset-sm10 offset-lg10>
        <download-excel
          class="ml-auto mr-0"
          :data="blackListUsers"
          :fields="json_fields"
          name="UsuáriosNãoAprovados.xls"
        >
          <v-btn small class="mr-4">
            <span class="pr-1">Exportar</span>
            <v-icon small class="black--text">insert_drive_file</v-icon>
          </v-btn>
        </download-excel>
      </v-flex >

      <v-data-table
        no-data-text="Nenhum usuário registrado"
        footer-props.items-per-page-text="Linhas por página"
        :headers="headers"
        :items="blackListUsers"
        :search="search"
        item-key="name"
        group-key="category"
        class="table-custom-vue elevation-1 mt-2"
        :rows-per-page-items="[10, 25, {'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
      >
        <template v-slot:items="props">
          <td class>{{ props.item.condominio }}</td>
          <td class>{{ props.item.name }}</td>
          <td class>{{ props.item.phone }}</td>
          <td class>{{ props.item.email }}</td>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn :disabled="!item.proof_of_address" icon style="text-decoration:none;" target="_blank" :href="`https://pickndrive.s3.amazonaws.com/${item.proof_of_address}`">
            <v-icon class="blue--text text--darken-4 ma-0">description</v-icon>
          </v-btn>
          <v-icon  class="error--text mr-3" @click="changeUser('delete'), userId = item.id">delete</v-icon>
          <v-icon  class="success--text" @click="changeUser('approve'), userId = item.id">done</v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { blockScreenUi } from "../../helpers/BlockScreenUi";
import UserController from "../../controllers/UserController";
import modalPadrao from "../shared/ModalPadrao.vue"

export default {
  components: {
    modalPadrao
  },

  data() {
    return {
      blockScreenData: blockScreenUi.blockScreenData,
      blockScreen: false,
      blackListUsers: [],
      search: "",
      json_fields: {
        "Nome": "name",
        "CPF": "cpf",
        "CNH": "drive_license",
        "Telefone": "phone"
      },
      headers: [
        { text: "Nome", value: "name" },
        { text: "CPF", value: "cpf" },
        { text: "CNH", value: "drive_license" },
        { text: "Telefone", value: "phone" }
      ],
      userController: new UserController(this.$resource),
      modalDialog: false,
      titleModal: "",
      userId: "",
      action: ""
    };
  },

  async created() {
    await this.getUsers();
  },

  methods: {
    getUsers() {
      this.userController
        .getBlackListUsers()
        .then(res => {
          this.blackListUsers = res;
        })
        .catch(error => {
          console.log(error);
        });
    },
  }
};
</script>

<style lang="scss">
.action-list button {
  float: right;
}
.table-custom-vue {
  margin: 20px;
}

.filtro-button {
  background: var(--primary-color-hover) !important;
}
</style>
